export default {
  opacity: (opacity = 0.5) => {
    return {
      MozOpacity: opacity,
      KhtmlOpacity: opacity,
      WebkitOpacity: opacity,
      opacity: opacity,
      MsFilter: 'progid:DXImageTransform.Microsoft.Alpha(opacity=' + opacity * 100 + ')',
      filter: 'alpha(opacity=@{opperc})'
    };
  },
  boxSizing: (sizing = 'border-box') => {
    return {
      MsBoxSizing: sizing,
      MozBoxSizing: sizing,
      WebkitBoxSizing: sizing,
      boxSizing:sizing
    };
  },
  boxShadow: shadow => {
    return {
      WebkitBoxShadow: shadow,
      MozBoxShadow: shadow,
      boxShadow: shadow
    };
  },
  transition: (seg = '.3s') => {
    return {
      WebkitTransition: seg,
      OTransition: seg,
      MsTransition: seg,
      MozTransition: seg,
      transition: seg
    };
  },
  clearFix: () => {
    return {
      '&::after': {
        display: 'block',
        content: "''",
        clear: 'both'
      }
    };
  },
  borderRadius: (topright = 0, bottomright = 0, bottomleft = 0, topleft = 0) => {
    return {
      MozBorderRadiusBottomleft: bottomleft,
      MozBorderRadiusBottomright: bottomright,
      MozBorderRadiusTopleft: topleft,
      MozBorderRadiusTopright: topright,
      WebkitBorderBottomLeftRadius: bottomleft,
      WebkitBorderBottomRightRadius: bottomright,
      WebkitBorderTopLeftRadius: topleft,
      WebkitBorderTopRightRadius: topright,
      borderBottomLeftRadius: bottomleft,
      borderBottomRightRadius: bottomright,
      borderTopLeftRadius: topleft,
      borderTopRightRadius: topright
    };
  },
  mixinBorderRadius: (radius = '2px') => {
    return {
      WebkitBorderRadius: radius,
      MozBorderRadius: radius,
      borderRadius: radius
    };
  },
  transform: value => {
    return {
      WebkitTransform: value,
      MozTransform: value,
      OTransform: value,
      MsTransform: value,
      transform: value
    };
  },
  appearanceNone: () => {
    return {
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      appearance: 'none'
    };
  },
  transitionAll: (value = '.3s') => ({
    WebkitTransition: value,
    OTransition: value,
    MsTransition: value,
    MozTransition: value,
    transition: value
  }),
  displayFlex: (direction = 'row', justifyContent = 'center', alignItems = 'center', gap = '0.5em') => ({
    display: '-webkit-box',
    display: '-moz-box',
    display: '-ms-flexbox',
    display: '-webkit-flex',
    display: 'flex',
    flexDirection: direction,
    justifyContent: justifyContent,
    alignItems: alignItems,
    gap: gap,
  }),
};

/*
  .background - size(@arguments) {
  -moz - background - size               : @arguments;
  background - size                    : @arguments;
}

  .background - clip(@argument: padding - box) {
  -moz - background - clip               : @argument;
  -webkit - background - clip            : @argument;
  background - clip                    : @argument;
}

  .gradient(@color: #F5F5F5, @start: #EEE, @stop: #FFF) {
  background: @color;
  background: -webkit - gradient(linear, left bottom, left top, color - stop(0, @start), color - stop(1, @stop));
  background: -ms - linear - gradient(bottom, @start, @stop);
  background: -moz - linear - gradient(center bottom, @start 0 %, @stop 100 %);
  background: -o - linear - gradient(@stop, @start);
  filter: e(% ("progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=0)", @stop, @start));
}

  .bw - gradient(@color: #F5F5F5, @start: 0, @stop: 255) {
  background: @color;
  background: -webkit - gradient(linear, left bottom, left top, color - stop(0, rgb(@start, @start, @start)), color - stop(1, rgb(@stop, @stop, @stop)));
  background: -ms - linear - gradient(bottom, rgb(@start, @start, @start) 0 %, rgb(@stop, @stop, @stop) 100 %);
  background: -moz - linear - gradient(center bottom, rgb(@start, @start, @start) 0 %, rgb(@stop, @stop, @stop) 100 %);
  background: -o - linear - gradient(rgb(@stop, @stop, @stop), rgb(@start, @start, @start));
  filter: e(% ("progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=0)", rgb(@stop, @stop, @stop), rgb(@start, @start, @start)));
}

  .mixin - borderRadius(@radius: 2px) {
  -webkit - border - radius              : @radius;
  -moz - border - radius                 : @radius;
  border - radius                      : @radius;
}

  .border - radius(@topright: 0, @bottomright: 0, @bottomleft: 0, @topleft: 0) {
  -moz - border - radius - bottomleft      : @bottomleft;
  -moz - border - radius - bottomright     : @bottomright;
  -moz - border - radius - topleft         : @topleft;
  -moz - border - radius - topright        : @topright;
  -webkit - border - bottom - left - radius  : @bottomleft;
  -webkit - border - bottom - right - radius : @bottomright;
  -webkit - border - top - left - radius     : @topleft;
  -webkit - border - top - right - radius    : @topright;
  border - bottom - left - radius          : @bottomleft;
  border - bottom - right - radius         : @bottomright;
  border - top - left - radius             : @topleft;
  border - top - right - radius            : @topright;
    .background - clip();
}

  // Crossbrowsing Flex
  .display(@a) when(@a = flex) {
  display: -webkit - box;
  display: -moz - box;
  display: -ms - flexbox;
  display: -webkit - flex;
  display: flex;
}
  .display(@a) when(@a = inline - flex) {
  display: -webkit - inline - flex;
  display: -ms - inline - flex;
  display: inline - flex;
}
  .justify - content(@a) {
    .ie10 - justify - content(@a);
  -webkit - justify - content: @a;
  justify - content: @a;
}
  .flex - direction(@a) {
    .ie10 - flex - direction(@a);
  -webkit - flex - direction: @a;
  -ms - flex - direction: @a;
  flex - direction: @a;
}
  .flex - wrap(@a) {
    .ie10 - flex - wrap(@a);
  -webkit - flex - wrap: @a;
  flex - wrap: @a;
}
  .flex(@a) {
  -ms - flex: @a;
  -webkit - flex: @a;
  flex: @a;
}
  .align - content(@a) {
    .ie10 - align - content(@a);
  -webkit - align - content: @a;
  align - content: @a;
}
  .align - items(@a) {
    .ie10 - align - items(@a);
  -webkit - align - items: @a;
  -ms - flex - align: @a;
  align - items: @a;
}
  .align - self(@a) {
    .ie10 - flex - align - self(@a);
  -webkit - align - self: @a;
  align - self: @a;
}
  .order(@a) {
  -ms - flex - order: @a;
  -webkit - order: @a;
  order: @a;
}
  .flex - shrink(@a: 1) {
  -webkit - flex - shrink: @a;
  -moz - flex - shrink: @a;
  flex - shrink: @a;
}

  //   ------------------   IE 10
  .ie10 - justify - content(@a) when(@a = space - between) {
  -webkit - box - pack: justify;
  -ms - flex - pack: justify;
}
  .ie10 - justify - content(@a) when(@a = space - around) {
  -webkit - box - pack: distribute;
  -ms - flex - pack: distribute;
}
  .ie10 - justify - content(@a) when(@a = flex - start) {
  -webkit - box - pack: start;
  -ms - flex - pack: start;
}
  .ie10 - justify - content(@a) when(@a = flex - end) {
  -webkit - box - pack: end;
  -ms - flex - pack: end;
}
  .ie10 - justify - content(@a) when(@a = center) {
  -webkit - box - pack: center;
  -ms - flex - pack: center;
}

  .ie10 - flex - direction(@a) when(@a = row) {
  -webkit - box - direction: normal;
  -moz - box - direction: normal;
  -webkit - box - orient: horizontal;
  -moz - box - orient: horizontal;
}
  .ie10 - flex - direction(@a) when(@a = row - reserve) {
  -webkit - box - direction: reverse;
  -moz - box - direction: reverse;
  -webkit - box - orient: normal;
  -moz - box - orient: normal;
}
  .ie10 - flex - direction(@a) when(@a = column) {
  -webkit - box - direction: normal;
  -moz - box - direction: normal;
  -webkit - box - orient: vertical;
  -moz - box - orient: vertical;
}
  .ie10 - flex - direction(@a) when(@a = column - reserve) {
  -webkit - box - direction: reverse;
  -moz - box - direction: reverse;
  -webkit - box - orient: vertical;
  -moz - box - orient: vertical;
}

  .ie10 - flex - wrap(@a) when(@a = nowrap) {
  -ms - flex - wrap: none;
}
  .ie10 - flex - wrap(@a) when(@a = wrap), (@a = wrap - reverse) {
  -ms - flex - wrap: @a;
}

  .ie10 - align - content(@a) when(@a = space - between) {
  -ms - flex - line - pack: justify;
}
  .ie10 - align - content(@a) when(@a = space - around) {
  -ms - flex - line - pack: distribute;
}
  .ie10 - align - content(@a) when(@a = flex - start) {
  -ms - flex - line - pack: start;
}
  .ie10 - align - content(@a) when(@a = flex - end) {
  -ms - flex - line - pack: end;
}
  .ie10 - align - content(@a) when(@a = center), (@a = stretch) {
  -ms - flex - line - pack: @a;
}

  .ie10 - align - items(@a) when(@a = flex - start) {
  -webkit - box - align: start;
  -moz - box - align: start;
  -ms - flex - align: start;
}
  .ie10 - flex - align - items(@a) when(@a = flex - end) {
  -webkit - box - align: end;
  -moz - box - align: end;
  -ms - flex - align: end;
}
  .ie10 - flex - align - items(@a) when(@a = center), (@a = baseline), (@a = stretch) {
  -webkit - box - align: @a;
  -moz - box - align: @a;
  -ms - flex - align: @a;
}

  .ie10 - flex - align - self(@a) when(@a = flex - start) {
  -ms - flex - item - align: start;
}
  .ie10 - flex - align - self(@a) when(@a = flex - end) {
  -ms - flex - item - align: end;
}
  .ie10 - flex - align - self(@a) when(@a = auto), (@a = center), (@a = baseline), (@a = stretch) {
  -ms - flex - item - align: @a;
}
  //   ------------------   END IE 10

  .column - count(@a: auto) {
  -moz - column - count: @a;
  -webkit - column - count: @a;
  column - count: @a;
}
  .column - gap(@a: normal) {
  -webkit - column - gap: @a;
  -moz - column - gap: @a;
  column - gap: @a;
}
  .word -break(@a: normal) {
  -moz - word -break: @a;
  -webkit - word -break: @a;
  word -break: @a;
}

  //* Shadows
  .drop - shadow(@x-axis: 0, @y-axis: 1px, @blur: 2px, @alpha: 0.1) {
  -webkit - box - shadow                 : @x-axis @y-axis @blur rgba(0, 0, 0, @alpha);
  -moz - box - shadow                    : @x-axis @y-axis @blur rgba(0, 0, 0, @alpha);
  box - shadow                         : @x-axis @y-axis @blur rgba(0, 0, 0, @alpha);
}
  .inner - shadow(@horizontal: 0, @vertical: 1px, @blur: 2px, @alpha: 0.4) {
  -webkit - box - shadow                 : inset @horizontal @vertical @blur rgba(255, 255, 255, @alpha);
  -moz - box - shadow                    : inset @horizontal @vertical @blur rgba(255, 255, 255, @alpha);
  box - shadow                         : inset @horizontal @vertical @blur rgba(255, 255, 255, @alpha);
}
  .box - shadow(@arguments) {
  -webkit - box - shadow                 : @arguments;
  -moz - box - shadow                    : @arguments;
  box - shadow                         : @arguments;
}

  //* Transitions elements
  .transitionAll(@s: .3s) { -webkit - transition: @s; -o - transition: @s; -ms - transition: @s; -moz - transition: @s; transition: @s; }

  //*tranform elements
  .transform(...) {
  -webkit - transform                  : @arguments;
  -moz - transform                     : @arguments;
  -o - transform                       : @arguments;
  -ms - transform                      : @arguments;
  transform: @arguments;
}

  //*Elements de tamany

  .box - sizing(@sizing: border - box) {
  -ms - box - sizing                     : @sizing;
  -moz - box - sizing                    : @sizing;
  -webkit - box - sizing                 : @sizing;
  box - sizing                         : @sizing;
}

  .user - select(@argument: none) {
  -webkit - user - select                : @argument;
  -moz - user - select                   : @argument;
  -ms - user - select                    : @argument;
  user - select                        : @argument;
}
  .appearance(@appearance) {
  -webkit - appearance : @appearance;
  -moz - appearance    : @appearance;
}

  .appearanceNone() {
  -webkit - appearance: none;
  -moz - appearance: none;
  appearance: none;
    &:: -ms - expand {
    display: none;
  }
}

  // LESS mixins: Genéricos
  .mixin - inputFixed(){ position: fixed; top: 0; left: -999px; width: 0; height: 0; opacity: 0; }

  .keyframes(@name; @arguments) {
  @-moz - keyframes @name { @arguments(); }
  @-webkit - keyframes @name { @arguments(); }
  @keyframes @name { @arguments(); }
}
  .animation(@arguments) {
  -webkit - animation: @arguments;
  -moz - animation: @arguments;
  animation: @arguments;
}

  .text - size(@text : none) {
  -moz - text - size - adjust    : @text;
  -ms - text - size - adjust     : @text;
  -webkit - text - size - adjust : @text;
}
}
*/
